import Axios from "axios";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import { refreshAccessToken } from "./apis/tokenRefresh";
import { clearSession, logout } from "./apis/session";

// "ResizeObserver loop completed with undelivered notifications" is a benign browser warning that
// antd popups raise when their anchor resizes or unmounts. CRA's dev overlay reports it as a fatal
// runtime error, so hide just that one message from the overlay in development.
if (process.env.NODE_ENV === "development") {
  window.addEventListener("error", (event) => {
    if (event.message?.startsWith("ResizeObserver loop")) {
      event.stopImmediatePropagation();
      document
        .getElementById("webpack-dev-server-client-overlay")
        ?.setAttribute("style", "display: none");
    }
  });
}

export const baseURL = process.env.REACT_APP_API_URL || "https://api-dev2.materialdepot.in/apiV1";
Axios.defaults.baseURL = baseURL;

Axios.defaults.headers.common.Authorization = localStorage["token"]
  ? `JWT ${localStorage.getItem("token")}`
  : "";
Axios.interceptors.response.use(
  (response) => response,
  async function (error: any) {
    const status = error.response?.status;
    const original = error.config;
    if ((status === 401 || status === 403) && original && !original._retried) {
      original._retried = true;
      const access = await refreshAccessToken();
      if (access) {
        Axios.defaults.headers.common.Authorization = `JWT ${access}`;
        original.headers = { ...original.headers, Authorization: `JWT ${access}` };
        return Axios(original);
      }
      return window.location.replace("/login");
    }
    return Promise.reject(error);
  }
);

// Store last logout date in local storage.
// If last logout date is less than today, remove token from local storage and reload the page to index.
Axios.interceptors.request.use((config: any) => {
  const lastLogoutDate = localStorage.getItem("lastLogoutDate");
  if (lastLogoutDate) {
    const lastLogout = new Date(lastLogoutDate);
    const today = new Date();
    // Only check the date, not the time.
    // If last logout date is less than today, remove token from local storage and reload the page to index.
    if (
      lastLogout.getDate() !== today.getDate() ||
      lastLogout.getMonth() !== today.getMonth() ||
      lastLogout.getFullYear() !== today.getFullYear()
    ) {
      logout();
    }
  } else {
    // If last logout date is not set, set it to today and remove token from local storage.
    localStorage.setItem("lastLogoutDate", new Date().toString());
    clearSession();
    window.location.href = "/login";
  }
  return config;
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
